import React, { Component } from 'react';
import isObject from 'lodash/isObject';
import { Check } from 'styled-icons/boxicons-regular/Check';
import { CaretDown } from 'styled-icons/boxicons-regular/CaretDown';
import styles from './styles.module.css';

class ListingSelect extends Component {
  state = {
    open: false,
  };

  onSelect = (value, direction) => {
    this.props.onChange(value, direction);
  };

  onToogleOpen = () => {
    this.setState(() => ({ open: true }), this.toogleActive);
  };

  toogleActive = () => {
    if (this.node) {
      const toogleActive = (event) => {
        if (event.target !== this.node) {
          this.setState(() => ({ open: false }));
          window.removeEventListener('click', toogleActive);
        }
      };
      window.addEventListener('click', toogleActive);
    }
  };

  render() {
    const { open } = this.state;
    const {
      className,
      value,
      direction,
      options: configOptions,
      currency,
    } = this.props;

    const options = [];
    configOptions.forEach((item) => {
      const value = isObject(item.value) ? item.value[currency] : item.value;
      const descendingOption = {
        label: `${item.label} (По убыванию)`,
        value,
        direction: 'desc',
      };

      const ascendingOption = {
        label: `${item.label} (По возрастанию)`,
        value,
        direction: 'asc',
      };

      options.push(descendingOption);
      options.push(ascendingOption);
    });

    const activeOption = options.find((option) => {
      return option.value === value && option.direction === direction;
    });

    let classes = [styles['listing-select']];
    if (className) classes.push(className);
    if (open) classes.push(styles['listing-select_open']);

    return (
      <div
        className={classes.join(' ')}
        ref={(node) => (this.node = node)}
        onClick={this.onToogleOpen}
      >
        <div className={styles['listing-select__current']}>
          <div className={styles['listing-select__current-label']}>
            {activeOption.label}
          </div>
          <CaretDown color='#78c810' size={15} />
        </div>
        <div className={styles['listing-select__options']}>
          {options.map((option, index) => {
            const classes = [styles['listing-select__option']];
            const isActive = activeOption.label === option.label;

            if (isActive) classes.push(styles['listing-select__option-active']);

            return (
              <div
                className={classes.join(' ')}
                key={`select-${index}`}
                onClick={() => this.onSelect(option.value, option.direction)}
              >
                <span>{option.label}</span>
                {isActive && <Check color='#fff' size={20} />}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default ListingSelect;
